import { OfficialViewService } from './official-view.service';
import { OfficialViewForPickleballComponent } from './official-view-for-pickleball/official-view-for-pickleball.component';
import { AddPointButtonComponent } from './add-point-button/add-point-button.component';
import { NetworkStatusComponent } from './../_shared/components/network-status/network-status.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { OfficialViewPageRoutingModule } from './official-view-routing.module';

import { OfficialViewPage } from './official-view.page';
import { TrackerBoardModule } from '../match-tracker/tracker-board/tracker-board.module';
import { StopwatchModule } from '../_shared/components/stopwatch/stopwatch.module';
import { ScoreListPageModule } from '../score-list/score-list.module';
import { InfringementListComponent } from './infringement-list/infringement-list.component';
import { InfringementDetailsComponent } from './infringement-list/infringement-details/infringement-details.component';
import { BallChangePolicyComponent } from './ball-change-policy/ball-change-policy.component';
import { BallChangeComponent } from './ball-change/ball-change.component';
import { EmptyPageModule } from '../empty-page/empty-page.module';
import { TranslateModule } from '@ngx-translate/core';
import { TrackerBarModule } from '../scoreboard/tracker-bar/tracker-bar.module';
import { SharedModule } from '../_shared/shared.module';
import { MatchDurationModule } from '../_shared/components/match-duration/match-duration.module';
import { StartMatchModule } from '../match-tracker/start-match/start-match.module';
import { PlayerBoxComponent } from './player-box/player-box.component';
import { ViolationShortcutsComponent } from './violation-shortcuts/violation-shortcuts.component';
import { TickerPipe } from './ticker.pipe';
import { PointRowComponent } from '../score-list/point-row/point-row.component';
import { SbBodyComponent } from '../scoreboard/sb-body/sb-body.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        OfficialViewPageRoutingModule,
        TrackerBoardModule,
        StopwatchModule,
        ScoreListPageModule,
        EmptyPageModule,
        TranslateModule.forChild(),
        TrackerBarModule,
        SharedModule,
        StartMatchModule,
        MatchDurationModule,
        NetworkStatusComponent,
        PointRowComponent,
        SbBodyComponent,
        OfficialViewForPickleballComponent,
        TickerPipe,
        AddPointButtonComponent,
    ],
    declarations: [
        OfficialViewPage,
        InfringementListComponent,
        BallChangeComponent,
        InfringementDetailsComponent,
        BallChangePolicyComponent,
        PlayerBoxComponent,
        ViolationShortcutsComponent,
    ],
    providers: [
        OfficialViewService
    ]
})
export class OfficialViewPageModule { }
